import GlobalHeader from './GlobalHeader.vue'
export default GlobalHeader
